module.exports = __webpack_public_path__ + "img/ttshop_dfk.7d92a0a1.svg";